import React from "react";

import { MediaKind } from "@perceptron/utils/types";

import { VideoDialog } from "@demo/components/VideoDialog";
import { MediaData } from "@demo/types/base";

import { AnnotationDialog } from "../AnnotationDialog/AnnotationDialog";

interface MediaPreviewModalProps {
  media: MediaData;
  mediaKind: MediaKind;
  isOpen: boolean;
  onClose: () => void;
  mediaSetId: string;
  currentMediaIndex: number;
  onChangeMediaIndex: (newIndex: number) => void;
}

export const MediaPreviewModal: React.FC<MediaPreviewModalProps> = ({
  media,
  mediaKind,
  isOpen,
  onClose,
  mediaSetId,
  currentMediaIndex,
  onChangeMediaIndex: onChangeMediaIndex,
}) => {
  // Use dedicated dialogs for each media type
  switch (mediaKind) {
    case MediaKind.Image:
      return (
        <AnnotationDialog
          currentImageIndex={currentMediaIndex}
          isOpen={isOpen}
          mediaSetId={mediaSetId}
          onChangeImageIndex={onChangeMediaIndex}
          onOpenChange={onClose}
        />
      );
    case MediaKind.Video:
      return <VideoDialog isOpen={isOpen} media={media} onOpenChange={onClose} />;
    default:
      return null;
  }
};
